import { render, staticRenderFns } from "./AddPersonalInformationModal.vue?vue&type=template&id=10d184e0&scoped=true&"
import script from "./AddPersonalInformationModal.vue?vue&type=script&lang=js&"
export * from "./AddPersonalInformationModal.vue?vue&type=script&lang=js&"
import style0 from "./AddPersonalInformationModal.vue?vue&type=style&index=0&id=10d184e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10d184e0",
  null
  
)

export default component.exports